import { render } from "./TableTemplate.vue?vue&type=template&id=bf66e184&scoped=true"
import script from "./TableTemplate.vue?vue&type=script&lang=js"
export * from "./TableTemplate.vue?vue&type=script&lang=js"

import "./TableTemplate.vue?vue&type=style&index=0&id=bf66e184&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf66e184"],['__file',"resources/js/components/insights/chart-building/chart_templates/TableTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf66e184"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf66e184', __exports__)) {
    api.reload('bf66e184', __exports__)
  }
  
  module.hot.accept("./TableTemplate.vue?vue&type=template&id=bf66e184&scoped=true", () => {
    api.rerender('bf66e184', render)
  })

}


export default __exports__